
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.437 2.5c1.39 0 2.553.514 3.49 1.542.938 1.027 1.407 2.25 1.406 3.666 0 .25-.014.497-.041.74a4.24 4.24 0 01-.146.719h-5.209l-1.416-2.125a.786.786 0 00-.292-.271.803.803 0 00-.885.062.86.86 0 00-.303.417l-1.125 3.375-.729-1.083a.785.785 0 00-.291-.271.803.803 0 00-.396-.104H1.854a4.256 4.256 0 01-.146-.719 6.322 6.322 0 01-.041-.719c0-1.43.465-2.66 1.395-3.687.93-1.028 2.09-1.542 3.48-1.542a4.57 4.57 0 011.885.396C9.017 3.16 9.542 3.528 10 4c.444-.472.962-.84 1.552-1.104a4.568 4.568 0 011.885-.396zM10 17.5c-.25 0-.49-.045-.719-.135a1.79 1.79 0 01-.615-.407l-5.583-5.604a3.772 3.772 0 01-.437-.52h4.396l1.416 2.124c.07.111.167.202.292.271.125.07.257.104.396.104.18 0 .347-.055.5-.166a.834.834 0 00.312-.417l1.125-3.375.708 1.083a.981.981 0 00.313.271c.125.07.257.104.396.104h4.833l-.208.25-.209.25-5.604 5.625c-.18.18-.382.316-.604.407-.222.09-.458.136-.708.135z","fill":"currentColor"}})])
          )
        }
      }
    